<template>
  <div class="tradetable">
    <p class="guowaip" style="margin-top:0">
     ◆ 机构的博易鑫管家 
    </p>
    <p class="guowaip" >
      ◆ 机构的恒生资产管理系统
    </p>
    <p class="guowaip" >
        ◆ 机构的杰宜斯金融管理系统  
    </p>
      <p class="guowaip" >
       ◆ 机构的金牛资产管理系统 
    </p>
    <p class="guowaip" >
       ◆ 机构的金仕达资管交易系统 
    </p>
    <p class="guowaip" >
        ◆ 机构的融航AMS资管平台 
    </p>
    <p class="guowaip" >
        ◆ 机构的文华<common-data name="appFullName_TMS"/>
    </p>
    <p class="guowaip" >
        ◆ 机构的迅投投资交易系统
    </p>
    <p class="guowaip" style="margin-top:22px">机构使用以上的技术系统，都支持对接。</p>
  </div>
</template>

<script>
export default {};
</script>

<style scpoed>
.tradetable {
  width: 720px;
  margin: 0 auto;
}
.guowaip {
  height: 30px;
  line-height: 30px;
  letter-spacing: 1px;
 margin-top: 15px;
 /* font-family: '仿宋' ,sans-serif; */
}
.acom {
  color: black;
  text-decoration: none;
  margin-right: 35px;
}
.acom:hover {
  color: black;
}
</style>